export default "__VITE_ASSET__1870aaba__"